import React from "react";
import { Checkbox } from "rsuite";
import { useLocation, useSearchParams } from "react-router-dom";
import styles from "./StatusFilter.module.scss";

interface StatusFilterProps {
  className?: string;
  showHeader?: boolean;
}

// Define all statuses based on backend analysis from temp.md
const STATUS_OPTIONS = [
  {
    value: "PENDING",
    label: "Za slanje",
    description: "Podsetnici koji čekaju da budu poslati",
  },
  {
    value: "WAITING",
    label: "Čeka registraciju",
    description: "Za korisnike koji nisu registrovani",
  },
  {
    value: "ORDERED",
    label: "Rezervisano",
    description: "Korisnik je rezervisao terapiju",
  },
  {
    value: "EXPIRED",
    label: "Isteklo",
    description: "Period za podizanje terapije je prošao",
  },
] as const;

export default function StatusFilter({
  className = "",
  showHeader = true,
}: StatusFilterProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  return (
    <div className={`${styles.statusFilter} ${className}`}>
      {showHeader && <div className={styles.smallHeader}>Status</div>}

      {STATUS_OPTIONS.map((status) => {
        const selectedStatuses = decodeURIComponent(
          searchParams.get("filter") || ""
        )
          .split(",")
          .filter(Boolean);

        const isSelected = selectedStatuses.includes(status.value);

        const handleCheckboxChange = () => {
          const updatedStatuses = isSelected
            ? selectedStatuses.filter((s) => s !== status.value)
            : [...selectedStatuses, status.value];

          const newSearchParams = new URLSearchParams(location.search);
          if (updatedStatuses.length > 0) {
            newSearchParams.set("filter", updatedStatuses.join(","));
          } else {
            newSearchParams.delete("filter");
          }
          setSearchParams(newSearchParams.toString());
        };

        return (
          <div
            key={status.value}
            className={styles.groupItem}
            title={status.description}
          >
            <Checkbox checked={isSelected} onChange={handleCheckboxChange}>
              {status.label}
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
}
